<template>
  <b-container v-if="aviso" fluid class="p-0">
    <b-card class="mx-3" no-body>
      <template #header>
        <header-sagres titulo="Editar Aviso" :botoes="botoesHeader" breakpoint="md" />
      </template>
      <b-tabs card fill>
        <b-tab title="Dados gerais do aviso" active>
          <div id="tabDadosGerais">
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form @submit.stop.prevent="handleSubmit(salvarAlteracoesDadosGerais)">
                <b-row>
                  <b-col cols="12">
                    <default-form-validation-provider label="Título" v-slot="defaultState">
                      <b-form-input id="input-titulo" :disabled="isAvisoInativo" v-model="aviso.Titulo"
                        :state="defaultState.state" type="text" maxlength="100" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" class="mb-3">
                    <span class="d-block text-left pb-1">Mensagem</span>
                    <div id="mensagemWrapper" :class="validarInputMensagem()">
                      <rich-text-editor @update-value="atualizarMensagem" :initial-content="aviso.Mensagem" />
                    </div>
                  </b-col>
                  <b-col cols="12" xl="6" class="d-flex flex-column align-items-end">
                    <b-table-simple striped>
                      <b-tbody>
                        <b-tr>
                          <b-td class="font-weight-bold text-right">ID</b-td>
                          <b-td class="text-left">{{ aviso.Id }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="font-weight-bold text-right">Situação</b-td>
                          <b-td class="text-left">{{ formatarSituacaoAviso(aviso.Ativo) }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="font-weight-bold text-right">Usuário criador</b-td>
                          <b-td class="text-left">{{ capitalize(aviso.UsuarioCadastro) }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="font-weight-bold text-right">Usuário última liberação</b-td>
                          <b-td class="text-left">{{ capitalize(aviso.UsuarioLiberacao) }}</b-td>
                        </b-tr>
                        <b-tr v-if="!mostrarEdicaoPermiteResposta">
                          <b-td class="font-weight-bold text-right">Permite resposta</b-td>
                          <b-td class="text-left">{{ simOuNao(aviso.PermiteResposta) }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="font-weight-bold text-right">Data de cadastro</b-td>
                          <b-td class="text-left">{{ formatDataHora(aviso.DataCadastro) }}</b-td>
                        </b-tr>
                        <b-tr>
                          <b-td class="font-weight-bold text-right">Última alteração</b-td>
                          <b-td class="text-left">{{ formatDataHora(aviso.DataUltAlteracao) }}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <default-form-validation-provider v-if="mostrarEdicaoPermiteResposta" label="Permite resposta?"
                      v-slot="defaultState">
                      <b-form-checkbox v-model="aviso.PermiteResposta" :state="defaultState.state" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" xl="6">
                    <default-form-validation-provider label="Protocolo / Processo vinculado" rules=""
                      v-slot="defaultState">
                      <b-form-input id="input-protproc" v-model="aviso.Protocolo" :state="defaultState.state"
                        type="text" maxlength="14" />
                    </default-form-validation-provider>
                    <default-form-validation-provider label="Departamento de Origem" rules="">
                      <multiselect v-model="aviso.Departamento" open-direction="bottom" :close-on-select="true"
                        :searchable="true" deselect-label="" :allow-empty="true" placeholder="Selecione um depto"
                        track-by="Id" :options="departamentos" label="Nome" :show-labels="false"
                        class="wrapper-multiselect-sagres">
                        <template slot="noOptions">
                          <small><i>Erro ao obter dados.</i></small>
                        </template>
                        <template slot="noResult">
                          <i>Sem resultados.</i>
                        </template>
                      </multiselect>
                    </default-form-validation-provider>
                    <default-form-validation-provider label="Data de Validade" v-slot="defaultState">
                      <b-form-datepicker id="input-dataValidade" :state="defaultState.state"
                        v-model="aviso.DataValidade" v-bind="datePickerProps" />
                    </default-form-validation-provider>
                  </b-col>
                  <b-col cols="12" class="d-flex justify-content-center">
                    <b-button size="sm" type="submit">
                      <font-awesome-icon icon="save" class="mr-2" />
                      Salvar alterações
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </div>
        </b-tab>
        <b-tab title="Anexos">
          <div id="tabAnexos">
            <b-button class="float-right mb-3" @click="mostrarModalAnexos = true">
              <font-awesome-icon icon="plus" class="mr-2" />
              Adicionar Anexo
            </b-button>
            <b-table :busy="isBusy" :fields="anexosFields" hover no-border-collapse :items="anexos" :sort-desc="true"
              striped small show-empty :per-page="anexosPerPage" :current-page="anexosCurrentPage">
              <template #empty>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #table-busy>
                <div class="text-center text-dark">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="loading-text">Carregando...</strong>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div v-if="false">
                  <span class="">{{}}</span>
                </div>
                <div v-else class="actions-icons">
                  <btn-download-component :fazerDownload="baixarAnexo" :parametros="row.item" />
                  <div class="wrapper-icon" @click="abrirModalExclusaoAnexo(row.item)">
                    <font-awesome-icon icon="trash" />
                    <div style="font-size: 12px">Remover</div>
                  </div>
                </div>
              </template>
            </b-table>
            <table-pagination :total-rows="anexos.length" :per-page="anexosPerPage" @pageChange="anexosPageChange">
            </table-pagination>
          </div>
        </b-tab>
        <b-tab title="Destinatários">
          <div id="tabDestinatarios">
            <b-button class="float-right mb-3" @click="mostrarModalDestinatarios = true">
              <font-awesome-icon icon="plus" class="mr-2" />
              Adicionar Destinatários
            </b-button>
            <b-button v-if="destinatarios.length > 0" variant="danger" class="float-right mb-3 mr-2"
              @click="removerTodosDestinatarios">
              <font-awesome-icon icon="ban" class="mr-2" />
              Remover todos
            </b-button>
            <b-table :busy="isBusy" :fields="destinatariosFields" hover no-border-collapse :items="destinatarios"
              :sort-desc="true" striped small show-empty :per-page="destinatariosPerPage"
              :current-page="destinatariosCurrentPage">
              <template #empty>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
              </template>
              <template #table-busy>
                <div class="text-center text-dark">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="loading-text">Carregando...</strong>
                </div>
              </template>
              <template v-slot:cell(actions)="row">
                <div v-if="false">
                  <span class="">{{}}</span>
                </div>
                <div v-else class="actions-icons">
                  <div class="wrapper-icon" @click="abrirModalExclusaoDestinatario(row.item)">
                    <font-awesome-icon icon="trash" />
                    <div style="font-size: 12px">Remover</div>
                  </div>
                </div>
              </template>
            </b-table>
            <table-pagination :total-rows="destinatarios.length" :per-page="destinatariosPerPage"
              @pageChange="destinatariosPageChange"></table-pagination>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal v-if="deleteDestinatario" id="confirm-delete-destinatario-modal" size="sm" button-size="sm" centered
      header-bg-variant="secondary" header-text-variant="light" header-class="" footer-class="" no-close-on-backdrop
      no-close-on-esc>
      <template v-slot:modal-header="">
        <h5>Confirmar remoção</h5>
      </template>
      Tem certeza que deseja remover o destinatário?
      <template v-slot:modal-footer="">
        <b-button size="sm" @click="removerDestinatario()"> Excluir </b-button>
        <b-button size="sm" variant="outline-secondary" @click="fecharModalExclusaoDestinatario()">
          Cancelar
        </b-button>
      </template>
    </b-modal>
    <b-modal v-if="deleteAnexo" id="confirm-delete-anexo-modal" size="sm" button-size="sm" centered
      header-bg-variant="secondary" header-text-variant="light" header-class="" footer-class="" modal-class="p-2"
      no-close-on-backdrop no-close-on-esc>
      <template v-slot:modal-header="">
        <h5>Confirmar remoção</h5>
      </template>
      Tem certeza que deseja remover o anexo {{ deleteAnexo.Nome }}?
      <template v-slot:modal-footer="">
        <b-button size="sm" @click="removerAnexo()"> Excluir </b-button>
        <b-button size="sm" variant="outline-secondary" @click="fecharModalExclusaoAnexo()">
          Cancelar
        </b-button>
      </template>
    </b-modal>
    <modal-selecionar-destinatarios v-if="mostrarModalDestinatarios" :idAviso="Number(idAviso)"
      @adicionouDestinatarios="getDestinatarios" @fecharModalDestinatarios="mostrarModalDestinatarios = false" />
    <modal-adicionar-anexo v-if="mostrarModalAnexos" @fecharModalAdicionarAnexo="fecharModalAdicionarAnexos()" />
    <modal-desativar-aviso v-if="mostrarModalDesativarAviso" :id-aviso="idAviso"
      @fecharModalDesativarAviso="fecharModalDesativarAviso()" />
  </b-container>
</template>

<script lang="ts">
import messagesService from "@/services/messagesService";
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import RichTextEditor from "@/components/RichTextEditor.vue";
import ModalSelecionarDestinatarios from "./ModalSelecionarDestinatarios.vue";
import ModalAdicionarAnexo from "./ModalAdicionarAnexo.vue";
import ModalDesativarAviso from "@/views/cadastro-avisos/ModalDesativarAviso.vue";
import { ValidationObserver } from "vee-validate";
import BtnDownloadComponent from "@/components/shared/btn-download.vue";
import { UtilsTS } from '@/utilsts';
import { store } from "@/store";
import { Component, Ref, Vue } from 'vue-property-decorator'
import { DatePickerDefaultProps } from '@/types/form-default-props'
import { fieldsDestinatarios } from "@/types/avisos/fields-destinatarios";
import { fieldsAnexos } from "@/types/avisos/fields-anexos";
import { mixins } from 'vue-class-component'
import { Aviso } from "@/types/avisos/aviso";
import HeaderSagres from '@/components/shared/HeaderSagres.vue';
import { BotaoSagres } from '@/types/botao-sagres';
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import { DepartamentoResumido } from "@/types/administracao/departamento-resumido";
import Multiselect from "vue-multiselect";

const CompProps = Vue.extend({
  name: 'EditarAviso',
  components: {
    BtnDownloadComponent,
    DefaultFormValidationProvider,
    HeaderSagres,
    ModalAdicionarAnexo,
    ModalDesativarAviso,
    ModalSelecionarDestinatarios,
    Multiselect,
    RichTextEditor,
    TablePagination,
    ValidationObserver,
  },
  props: {
    idAviso: {
      type: String,
      required: true,
    },
  },
})

@Component
export default class CriarAviso extends mixins(UtilsTS, CompProps) {
  @Ref('observer') observer: InstanceType<typeof ValidationObserver>

  botoesHeader: BotaoSagres[] = [
    {
      id: 3,
      icone: 'times',
      texto: 'Desativar este aviso',
      acao: this.mostrarModalDesativar,
    },
    {
      id: 2,
      icone: 'plus',
      texto: 'Novo aviso',
      acao: this.criarAviso,
    },
    {
      id: 1,
      icone: 'chevron-left',
      texto: 'Voltar',
      url: '/avisos/cadastro',
      variant: 'outline-secondary',
    },
  ]

  departamentos: DepartamentoResumido[] = []
  datePickerProps = DatePickerDefaultProps
  mostrarModalDestinatarios = false
  mostrarModalAnexos = false
  aviso: Aviso | null = null
  destinatarios: any[] = []
  anexos: any[] = []
  isBusy = true

  destinatariosFields = fieldsDestinatarios
  destinatariosPerPage = 10
  destinatariosCurrentPage = 1

  anexosFields = fieldsAnexos
  anexosPerPage = 10
  anexosCurrentPage = 1

  inputMensagemMudou = false

  deleteDestinatario: any = null
  deleteAnexo: any = null

  mostrarModalDesativarAviso = false

  get isAvisoInativo() {
    return this.aviso?.Ativo == 0;
  }

  get mostrarEdicaoPermiteResposta() {
    return this.aviso && (!this.aviso.Respostas || this.aviso.Respostas.length === 0) && (!this.aviso.Visualizacoes || this.aviso.Visualizacoes.length === 0)
  }

  abrirModalExclusaoDestinatario(item) {
    this.deleteDestinatario = item;
    this.$bvModal.show("confirm-delete-destinatario-modal");
  }

  fecharModalExclusaoDestinatario() {
    this.deleteDestinatario = null;
    this.$bvModal.hide("confirm-delete-destinatario-modal");
  }

  async fecharModalDesativarAviso() {
    this.mostrarModalDesativarAviso = false;
    await this.getAviso(this.idAviso);
  }

  abrirModalExclusaoAnexo(item) {
    this.deleteAnexo = item;
    this.$bvModal.show("confirm-delete-anexo-modal");
  }
  fecharModalExclusaoAnexo() {
    this.deleteAnexo = null;
    this.$bvModal.hide("confirm-delete-anexo-modal");
  }

  async fecharModalAdicionarAnexos() {
    this.mostrarModalAnexos = false;
    await this.getAnexos(this.idAviso);
  }

  mostrarModalDesativar() {
    this.mostrarModalDesativarAviso = true
  }

  atualizarMensagem(value) {
    if (this.aviso) {
      this.aviso.Mensagem = value;
      this.inputMensagemMudou = true;
    }
  }
  getValidationState({ dirty, validated, valid = null }) {
    return dirty || validated ? valid : null;
  }
  destinatariosPageChange(value) {
    this.destinatariosCurrentPage = value;
  }
  anexosPageChange(value) {
    this.anexosCurrentPage = value;
  }

  async getAviso(id) {
    try {
      this.isBusy = true;
      const avisoResponse = await messagesService.getAviso(id);
      this.aviso = avisoResponse.aviso;
      if (avisoResponse.respostas?.length) this.aviso.Respostas = avisoResponse.respostas
      if (avisoResponse.visualizacoes?.length) this.aviso.Visualizacoes = avisoResponse.visualizacoes
      if (this.aviso && this.aviso.IdDepartamento) this.aviso.Departamento = this.departamentos.find(d => d.Id === this.aviso?.IdDepartamento)
    } catch (e: any) {
      this.tratarError(e)
    } finally {
      this.isBusy = false;
    }
  }

  async getDestinatarios(id) {
    this.isBusy = true;

    const response = await messagesService.getDestinatarios(id);
    if (response && response.status == 200) {
      this.destinatarios = response.data.destinatarios;
    } else {
      this.$toast.error("Erro ao obter lista de destinatários");
    }

    this.isBusy = false;
  }

  async getAnexos(id) {
    this.isBusy = true;

    const response = await messagesService.getAnexosAviso(id);
    if (response && response.status == 200) {
      this.anexos = response.data;
    } else {
      this.$toast.error("Erro ao obter anexos");
    }

    this.isBusy = false;
  }

  async baixarAnexo(arquivo) {
    const response = await messagesService.baixarAnexo(arquivo.Id);
    if (response && response.status == 200)
      this.download(arquivo.Nome, response.data);
    else {
      this.$toast.error("Erro ao baixar o arquivo solicitado.");
    }
  }

  async removerAnexo() {
    const response = await messagesService.removerAnexo(this.deleteAnexo.Id);
    if (response && response.status == 200) {
      await this.getAnexos(this.idAviso);
      this.$toast.success("Anexo removido com sucesso.");
    } else {
      this.$toast.error("Erro ao remover o arquivo solicitado.");
    }

    this.fecharModalExclusaoAnexo();
  }

  validarInputMensagem() {
    if (!this.inputMensagemMudou) return "";

    if ((this.inputMensagemMudou &&
      (!this.aviso || this.aviso.Mensagem == null ||
        this.aviso.Mensagem == "" ||
        this.aviso.Mensagem == " "))
    ) {
      return "invalid";
    }

    if (
      (this.inputMensagemMudou &&
        (!this.aviso || this.aviso.Mensagem != null ||
          this.aviso.Mensagem != "" ||
          this.aviso.Mensagem != " ")) ||
      !this.aviso ||
      this.aviso.Mensagem != null ||
      this.aviso.Mensagem != "" ||
      this.aviso.Mensagem != " "
    ) {
      return "valid";
    }
  }

  async removerDestinatario() {
    const response = await messagesService.removerDestinatario(
      this.deleteDestinatario.idDestinatario
    );
    if (response && response.status == 200) {
      const responseDestinatarios = await messagesService.getDestinatarios(
        Number(this.idAviso)
      );
      this.destinatarios = responseDestinatarios.data.destinatarios;
      this.$toast.success("Destinatario removido com sucesso");
    } else if (response && response.data.msg && response.status == 400) {
      this.$toast.error(response.data.msg)
    } else {
      this.$toast.error("Não foi possível remover o destinatário");
    }

    this.deleteDestinatario = null;
    this.$bvModal.hide("confirm-delete-modal");
  }

  async salvarAlteracoesDadosGerais() {
    const isValid = await this.observer.validate();
    if (!isValid) return

    if (!this.aviso || !this.aviso.Mensagem || this.aviso.Mensagem.length == 0) {
      this.$toast.error("Preencha a mensagem do aviso")
      return
    }
    if (this.aviso.Departamento !== null) this.aviso.IdDepartamento = this.aviso.Departamento?.Id

    const response = await messagesService.editarAviso(this.aviso);

    if (response && response.status == 200) {
      await this.getAviso(this.idAviso);
      this.$toast.success("Aviso alterado com sucesso");
    } else {
      this.$toast.error(response.data.msg || "Erro ao alterar o aviso");
    }
  }

  criarAviso() {
    this.$router.push("/avisos/criar/");
  }

  async removerTodosDestinatarios() {
    this.$bvModal.msgBoxConfirm('Tem certeza que deseja remover todos os destinatários deste aviso?', {
      buttonSize: 'sm',
      cancelTitle: 'Não',
      cancelVariant: 'outline-secondary',
      centered: true,
      headerBgVariant: 'secondary',
      headerTextVariant: 'light',
      okTitle: 'Sim',
      title: 'Confirmar remoção de destinatários',
    }).then(async (value) => {
      if (value) {
        try {
          store.blockScreen = true
          const response = await messagesService.excluirTodosDestinatarios(Number(this.idAviso));
          const msg = `Destinatários removidos com sucesso${response.naoRemovidos > 0 ? `(exceto ${response.naoRemovidos}).` : '!'}`
          this.$toast.success(msg)
          this.getDestinatarios(this.idAviso)
        } catch (e) {
          this.tratarError(e)
        } finally {
          store.blockScreen = false
        }
      }
    }).catch(err => {
      console.error('Erro ao operar o dialog de exclusão de destinatários', err)
    })
  }
  async mounted() {
    this.departamentos = await messagesService.getDepartamentosOrigemAvisos();
    await this.getAviso(this.idAviso);
    await this.getDestinatarios(this.idAviso);
    await this.getAnexos(this.idAviso);
  }
}
</script>

<style scoped>
#mensagemWrapper {
  width: 100% !important;
}

#mensagemWrapper.invalid .tox-tinymce {
  border: #dc3545 solid 1px !important;
  border-radius: 3px !important;
}

#mensagemWrapper.valid .tox-tinymce {
  border: #28a745 solid 1px !important;
  border-radius: 3px !important;
}

#mensagemWrapper label {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}
</style>